(function () {
  'use strict';

  function initProductTabs(product) {
    var mode = product.getAttribute('data-panel-mode') || 'grid';
    var tabBtns = product.querySelectorAll('[data-sc-product-tab]');
    var panels = product.querySelectorAll('[data-sc-panel]');

    if (!tabBtns.length || !panels.length) return;

    function activateTab(name) {
      tabBtns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-sc-product-tab') === name;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-sc-panel') === name;
        if (mode === 'tabs') {
          panel.classList.toggle('is-active', isActive);
        } else if (isActive) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.getAttribute('data-sc-product-tab'));
      });
    });

    if (mode === 'grid') {
      panels.forEach(function (panel) {
        panel.classList.add('is-active');
      });
    }
  }

  function initSupportCenter(root) {
    if (!root || root.dataset.scInitialized === 'true') return;
    root.dataset.scInitialized = 'true';

    var searchInputs = document.querySelectorAll('[data-sc-search-input]');
    var searchBtns = document.querySelectorAll('[data-sc-search-btn]');
    var chips = root.querySelectorAll('[data-sc-chip]');
    var products = root.querySelectorAll('.sc-support__product');
    var emptyState = root.querySelector('[data-sc-empty-state]');

    var activeCategory = 'all';

    products.forEach(initProductTabs);

    function normalize(value) {
      return (value || '').toLowerCase().trim();
    }

    function getSearchQuery() {
      var query = '';
      searchInputs.forEach(function (input) {
        if (input.value) {
          query = input.value;
        }
      });
      return normalize(query);
    }

    function applyFilters() {
      var query = getSearchQuery();

      products.forEach(function (product) {
        var category = product.getAttribute('data-category') || '';
        var searchText = normalize(product.getAttribute('data-search'));
        var categoryMatch = activeCategory === 'all' || category === activeCategory;
        var searchMatch = !query || searchText.indexOf(query) !== -1;
        var visible = categoryMatch && searchMatch;

        product.classList.toggle('is-hidden', !visible);
      });

      var visibleCount = root.querySelectorAll('.sc-support__product:not(.is-hidden)').length;

      if (emptyState) {
        emptyState.classList.toggle('is-visible', visibleCount === 0);
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (item) {
          item.classList.remove('active');
        });
        chip.classList.add('active');
        activeCategory = chip.getAttribute('data-category') || 'all';
        applyFilters();
      });
    });

    searchBtns.forEach(function (btn) {
      btn.addEventListener('click', applyFilters);
    });

    searchInputs.forEach(function (input) {
      input.addEventListener('input', applyFilters);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyFilters();
        }
      });
    });

    applyFilters();
  }

  function boot() {
    document.querySelectorAll('[data-section-type="support-center"]').forEach(initSupportCenter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="support-center"]');
    if (section) initSupportCenter(section);
  });
})();
